var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:['c-hotspot', '_test', _vm.spotSize, 'c-hotspot--' + _vm.spotActive, _vm.customFade, _vm.isPlaced()],style:(_vm.spotStyle),attrs:{"id":"hot-spot"}},_vm.$listeners),[_c('LargeBlueHotSpot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }